import { render } from "./PpcBAVsLastWeekSpendCell.vue?vue&type=template&id=a8b69a40&scoped=true"
import script from "./PpcBAVsLastWeekSpendCell.vue?vue&type=script&lang=js"
export * from "./PpcBAVsLastWeekSpendCell.vue?vue&type=script&lang=js"

import "./PpcBAVsLastWeekSpendCell.vue?vue&type=style&index=0&id=a8b69a40&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8b69a40"]])

export default __exports__